var _defs, _g, _g2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:47px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.86,38.11c29.43,0,57.95,5.76,84.79,17.11,25.94,10.97,49.24,26.69,69.26,46.71,20.02,20.03,35.74,43.33,46.71,69.28,11.35,26.84,17.11,55.38,17.11,84.81s-5.76,57.97-17.11,84.81c-10.97,25.94-26.69,49.25-46.71,69.28-20.02,20.02-43.32,35.74-69.26,46.71-26.83,11.35-55.36,17.11-84.79,17.11s-57.95-5.76-84.79-17.11c-25.94-10.97-49.24-26.69-69.26-46.71-20.02-20.03-35.74-43.33-46.71-69.28-11.35-26.84-17.11-55.38-17.11-84.81s5.76-57.97,17.11-84.81c10.97-25.94,26.69-49.25,46.71-69.28,20.02-20.02,43.32-35.74,69.26-46.71,26.83-11.35,55.36-17.11,84.79-17.11M255.86,.11C114.55,.11,0,114.68,0,256.02s114.55,255.91,255.86,255.91,255.86-114.58,255.86-255.91S397.17,.11,255.86,.11h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 255.44,
    cy: 159.87,
    r: 32.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M300.55,360.57c-27.94-.09-55.88-.17-83.83-.26h41.36v-114.89h-34.13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleInfo);
export default __webpack_public_path__ + "static/media/circle-info.6bdf19b34cd62fd0d84249b1269c2faa.svg";
export { ForwardRef as ReactComponent };